module.exports = __webpack_public_path__ + "images/category_lp/watch/quote_d4e65300b62f89a1e79c58e548039de4.png";